let config = {
  mapStyle: "mapbox://styles/counterglow/ckautlqhp2o1h1ik49kc16a5v",
  mapBoxKey:
    "pk.eyJ1IjoiY291bnRlcmdsb3ciLCJhIjoiY2s5d3piZ2k4MGV1aTNmbXJ1Yzk0Z285aSJ9.C8wv6mq-DgKj96ecKainsA",
  farmLayer: "Counterglow farms",
}

export default config
